module.exports = __webpack_public_path__ + "fonts/lato-regular.0e4db18.woff";